import React from 'react'

export default props => (
    <tbody>
		{props.children}
	</tbody>
)
